import axios, { AxiosRequestHeaders, InternalAxiosRequestConfig } from 'axios';

const instance = axios.create();

//do other things to axios, like intercept requests and add valid bearer token, etc.
instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    //const tokenKeys = JSON.parse(localStorage.getItem(`msal.token.keys.${clientId}`) as string);
    //const accessToken = JSON.parse(localStorage.getItem(tokenKeys.accessToken[0]) as string);

    const accessToken = localStorage.getItem('ccid');

    if (config.headers === undefined) {
        config.headers = {} as AxiosRequestHeaders;
    }

    if (!config.headers.Authorization && !!accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
});

export default instance;